import { gql } from 'apollo-angular';

export const GET_OFFER_ATTACHMENTS = gql`
  query getOfferAttachments($id: Long!) {
    offer(id: $id) {
      id
      attachments {
        legacyAttachments
        attachments {
          fileName
          fileId
        }
      }
    }
  }
`;
